// A stubbed out version of node_modules/cql-exec-fhir/lib/modelInfos/fhir-modelinfo-*.xml.js
// for modelinfos we don't use that take up a lot of space.
const empty = '';
export default empty;
